export const SET_DEFAULT_WALLET_START = 'SET_DEFAULT_WALLET_START';
export const SET_DEFAULT_WALLET_SUCCESS =
  'SET_DEFAULT_WALLET_SUCCESS';
export const SET_DEFAULT_WALLET_ERROR = 'SET_DEFAULT_WALLET_ERROR';
export const SET_DEFAULT_WALLET_END = 'SET_DEFAULT_WALLET_END';
export const SET_DEFAULT_WALLET_CLEAR = 'SET_DEFAULT_WALLET_CLEAR';
